import { each, toNumber } from 'lodash';

const MET_DEFAULTS = {
  F: {
    age: 35,
    weight: 75,
    height: 165,
  },
  M: {
    age: 35,
    weight: 85,
    height: 175,
  },
};

const WEIGHT_ROUND_MULTIPLES = [
  { threshold: 30, multiple: 5 },
  { threshold: 10, multiple: 2.5 },
  { threshold: 0, multiple: 0.5 },
];

const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

export const calculateDaysElapsed = startedAt => {
  if (startedAt) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDay = new Date(startedAt);
    startDay.setHours(0, 0, 0, 0);

    return Math.ceil((today - startDay) / MILLISECONDS_IN_DAY);
  }

  return 0;
};

export const calculateAge = birthday => {
  const today = new Date();
  const birthDate = new Date(birthday);
  const monthDiff = today.getMonth() - birthDate.getMonth();

  let age = today.getFullYear() - birthDate.getFullYear();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age = age - 1;
  }

  return age;
};

export const calculateMetFor = (member, met, totalTime) => {
  const gender = member.profile.gender || 'F';
  const age = calculateAge(member.profile.birthday);
  const duration =
    totalTime.hours * 60 * 60 + totalTime.minutes * 60 + totalTime.seconds;

  return calculateMet(gender, {
    weight: member.startWeightInKg,
    height: member.profile.height,
    age,
    met,
    duration,
  });
};

export const calculateMet = (gender, params) => {
  params = { ...MET_DEFAULTS[gender], ...params };

  if (params.duration) {
    let rmr;

    if (gender === 'M') {
      rmr =
        88.362 +
        13.397 * toNumber(params.weight) +
        4.799 * toNumber(params.height) -
        5.677 * toNumber(params.age);
    } else {
      rmr =
        447.593 +
        9.247 * toNumber(params.weight) +
        3.098 * toNumber(params.height) -
        4.33 * toNumber(params.age);
    }

    const caloriesBurnt =
      rmr / 1440 * toNumber(params.met) * toNumber(params.duration / 60);

    return Math.max(0, caloriesBurnt);
  } else {
    return 0;
  }
};

export const calculateBmi = (weight = 0, height = 0) => {
  const metres = height / 100;
  const bmi = weight / (metres * metres);
  return mround(weight / (metres * metres), 0.1);
};

export const convertWeight = (weight, gender, round = true) => {
  if (gender === 'F') {
    return weight;
  }

  // Gender bias
  const genderBias = 1.25;
  weight = weight * genderBias;

  // Rounding
  if (round) {
    each(WEIGHT_ROUND_MULTIPLES, data => {
      if (weight > data.threshold) {
        weight = mround(weight, data.multiple);
        return false;
      }
    });
  }

  return weight;
};

export const mround = (number, multiple) => {
  const multiplier = 1 / multiple;
  return Math.round(number * multiplier) / multiplier;
};



// WEBPACK FOOTER //
// ./src/utils/calculators.js